import React, { useState } from "react";
import data from "../../data/index.json";

export default function Avis() {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className="testimonial--section" id="Avis">
      <div className="formations--container-box">
        <div className="formations--container">
          <p className="sub--title">⭐ Plus de 180 élèves satisfaits</p>
          <h2 className="sections--heading">Voici leur <span style={{color: 'var(--primary)'}} >retour d'expérience</span>{" "}après nous avoir fait <span style={{color: 'var(--primary)'}} >confiance</span>{" "}!</h2>
        </div>
        <a
          activeClass="navbar--active-content"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
          href="https://www.google.com/search?sa=X&sca_esv=580163193&hl=fr-BE&tbm=lcl&sxsrf=AM9HkKm5ItrM7d3eMSmOFKvYMFdAdqI9Lg:1699374958224&q=Directt+Permis+Avis&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxIxNDI1MLIwMbI0tzA0NTUyNLU0NtzAyPiKUdglsyg1uaREISC1KDezWMGxLLN4ESs2UQBgkhomRwAAAA&rldimm=12502842978155215931&ved=2ahUKEwidiuaFqbKCAxWQUKQEHY-qAqkQ9fQKegQIRhAF&biw=1389&bih=651&dpr=1.38#lkt=LocalPoiReviews"
          target="_blank"
          className="navbar--content"
        >
          <button className="btn btn-primary">
            <b>+ Voir plus d'avis !</b>
          </button>
        </a>
      </div>
      {/*
      <div className="formations--section--container">
        {data?.avis?.map((item, index) => (
          <div key={index} className="testimonial--section--card">
            <div className="testimonial--section--card--review">
              {Array.from({ length: 5 }, (reviews, index) => (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="27"
                  height="26"
                  viewBox="0 0 27 26"
                  fill="none"
                >
                  <path
                    d="M12.0945 0.953177C12.5528 -0.135435 14.1138 -0.135434 14.5722 0.95318L17.2772 7.37836C17.4705 7.8373 17.9074 8.15087 18.4089 8.19059L25.4302 8.74669C26.6199 8.84091 27.1022 10.3076 26.1959 11.0746L20.8464 15.6016C20.4643 15.925 20.2973 16.4324 20.4141 16.9158L22.0484 23.6847C22.3253 24.8315 21.0625 25.7381 20.044 25.1235L14.0327 21.4961C13.6033 21.237 13.0633 21.237 12.634 21.4961L6.62265 25.1235C5.60415 25.7381 4.34127 24.8315 4.61818 23.6847L6.25256 16.9158C6.3693 16.4324 6.20243 15.925 5.82034 15.6016L0.47075 11.0746C-0.435624 10.3076 0.0467572 8.84091 1.23639 8.74669L8.25781 8.19059C8.75933 8.15087 9.19621 7.8373 9.38942 7.37836L12.0945 0.953177Z"
                    fill="var(--primary)"
                  />
                </svg>
              ))}/5
            </div>
            <p className="text-md">{item.description}</p>
            <div className="testimonial--section--card--author--detail">
              <img src={item.src} style={{maxWidth: '5rem'}} alt="Avatar" />
              <div>
                <p className="text-md testimonial--author--name">
                  {item.author_name}
                </p>
                <p className="text-md testimonial--author--designation">
                  {item.author_designation}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
      */}
      {/*1st https://a8f24594d0af45b1a62ebe223aa69962.elf.site/ */}
      {/*2nd https://8f7d3fff072340c5937236604e46f35a.elf.site/ */}
      <script style={{ overflow: 'hidden :important'}} src="https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.2.10/iframeResizer.min.js"></script>
      <iframe onload="iFrameResize(this)" src="https://a8f24594d0af45b1a62ebe223aa69962.elf.site/" style={{border:'none', width:'100%', height:'32rem', overflow: 'hidden :important'}}></iframe>
      <div className="formations--container-box">
        <div className="formations--container">
          <h2 className="sections--heading"><b>✍ Questionnaire de satisfaction</b></h2>
          <p className="sub--title">
            Merci de télécharger le questionnaire et de nous l'envoyer par email 😉<br />
            <a style={{color: 'var(--primary)'}}  href="mailto:m.directtpermis@gmail.com">m.directtpermis@gmail.com</a> 📧<br />
            Ou y répondre directement sur <a style={{color: '#6639b6'}} target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSckB6rXHTNFeHF30-pSbkN42-JEtr3KgntLd-OSzOg0dKj9mg/viewform">Google Forms</a> 📄
          </p>
        </div>
        <div>
          <a
            activeClass="navbar--active-content"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            href="./pdf/DirecttPermis-Questionnaire_satisfaction.pdf"
            download="DirecttPermis-Questionnaire_satisfaction.pdf"
            className="navbar--content"
          >
            <button className="btn btn-primary">
              <b>Télécharger le questionnaire</b>
            </button>
          </a>
          <a
            onClick={() => setShowModal(true)}
            rel="noreferrer"
            style={{verticalAlign: "middle", marginLeft: "1rem"}}
          >
            <svg fill="#000000" width="48px" height="48px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 4h4V2H2v6h2zM4 16H2v6h6v-2H4zM20 20h-4v2h6v-6h-2zM16 4h4v4h2V2h-6z"/><path d="M5 11h6V5H5v6zm2-4h2v2H7V7zM5 19h6v-6H5v6zm2-4h2v2H7v-2zM19 5h-6v6h6V5zm-2 4h-2V7h2v2zM13 13h2v2h-2zM15 15h2v2h-2zM17 17h2v2h-2zM17 13h2v2h-2z"/>
            </svg>
          </a>
          {showModal ? (
          <>
            <div
              style={{justifyContent: 'center', alignItems: 'center', display: 'flex', top: '0', right: '0', bottom: '0', left: '0', padding: '1rem', overflowX: 'hidden', overflowY: 'auto', position: 'fixed', inset: '0', zIndex: '50', outlineStyle: 'none', cursor: 'default'}}
            >
              <div style={{position: 'relative', width: 'auto', marginTop: '1.5rem', marginBottom: '1.5rem', marginLeft: 'auto', marginRight: 'auto', maxWidth: '48rem'}}>
                {/*content*/}
                <div style={{borderWidth: '0', borderRadius: '0.5rem', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)', position: 'relative', display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#ffffff', outlineStyle: 'none'}}>
                  {/*header*/}
                  <div style={{display: 'flex', padding: '1.25rem', justifyContent: 'space-between', alignItems: 'flex-start', borderTopLeftRadius: '0.5rem', borderTopRightRadius: '0.5rem', borderTopWidth: '0px', borderLeftWidth: '0px', borderRightWidth: '0px', borderBottomWidth: '1px', borderStyle: 'solid', borderColor: '#ff000042'}}>
                    <h3 style={{fontSize: '1.25rem', lineHeight: '1.75rem', fontWeight: '600', color: 'var(--primary)' }}>
                      📸 QR Code Questionnaire
                    </h3>
                    <button
                      style={{float: 'right', padding: '0.25rem', borderWidth: '0', outlineStyle: 'none', fontSize: '1.875rem', lineHeight: '2.25rem', fontWeight: '600', lineHeight: '1', color: '#000000', backgroundColor: 'transparent', opacity: '0.05'}}
                      onClick={() => setShowModal(false)}
                    >
                      <span style={{display: 'block', outlineStyle: 'none', width: '1.5rem', height: '1.5rem', fontSize: '1.5rem', lineHeight: '2rem', color: '#000000', backgroundColor: 'transparent', opacity: '0.05'}}>
                        ×
                      </span>
                    </button>
                  </div>
                  {/*body*/}
                  <div style={{position: 'relative', padding: '1.5rem', flex: '1 1 auto', textAlign: 'center'}}>
                  <img src="./img/logoDPhead.jpg" style={{maxWidth: '12rem'}} alt="Directt Permis" />
                    <ul style={{listStyle: 'none', paddingInlineStart: 'initial'}}>
                      <li><img src="./img/www.directt-permis.com-questionnaire.png" style={{display: 'inline-flex', width: '15rem', verticalAlign: 'middle'}} alt="QR Code" /></li>
                    </ul>
                  </div>
                  {/*footer*/}
                  <div style={{display: 'flex', padding: '0.5rem', justifyContent: 'flex-end', alignItems: 'center', borderBottomRightRadius: '0.5rem', borderBottomLeftRadius: '0.5rem', borderTopWidth: '1px',borderLeftWidth: '0px', borderRightWidth: '0px', borderBottomWidth: '0px', borderStyle: 'solid', borderColor: '#ff000042'}}>
                    <button
                      style={{color: 'var(--primary)', paddingTop: '0.5rem', paddingBottom: '0.5rem', paddingLeft: '1.5rem', paddingRight: '1.5rem', marginRight: '0.25rem', marginBottom: '0.25rem', outlineStyle: 'none', fontSize: '0.875rem', lineHeight: '1.25rem', fontWeight: '700', textTransform: 'uppercase', transitionProperty: 'all', transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)', transitionDuration: '150ms', transitionTimingFunction: 'linear', border: 'none', background: 'transparent', cursor: 'pointer'}}
                      type="button"
                      onClick={() => setShowModal(false)}
                    >
                      J'ai scanné ✅
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div style={{position: 'fixed', top: '0', right: '0', bottom: '0', left: '0', zIndex: '40', backgroundColor: '#000000', opacity: '0.25'}}></div>
          </>
          ) : null}
        </div>
      </div>
    </section>
  );
}
